import axios from "axios";

export const API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export function formatApiError(error, fallback = "Die Aktion konnte nicht abgeschlossen werden. Bitte erneut versuchen.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || JSON.stringify(item)).join(" ");
  return fallback;
}
